import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EfEmarsysDialogB from '@elem/ui/ef-emarsys-dialog-b';
import EfIcon from '@elem/ui/ef-icon';
import EfShopIconsA from '@elem/ui/ef-shop-icons-a';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import { Fragment, useEffect, useState } from 'react';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductStore } from '../../ProductProvider';
import EmailBox from './EmailBox';
import BtnA from './icons/BtnA';
import IconAdd from './icons/IconAdd';
import styles from './index.module.scss';
import { LinkConfigAll } from './LinkConfig';

const CONTACT_LIST_ID: any = {
    us: ['1831281292', '1157235157'],
    ca: ['1831281292', '1157235157'],

    eu: ['1831281292', '1157235157'],
    uk: ['1831281292', '1157235157'],
    it: ['1831281292', '1157235157'],
    es: ['1831281292', '1157235157'],
    de: ['1831281292', '1157235157'],
    fr: ['1831281292', '1157235157'],
};

export default function TheComp() {
    const { pageStatus } = useProductStore();
    const isStatusNext = pageStatus !== IPageStatus.statusA;
    const { t } = useLang('theProduct.OtherA');
    const { locale } = getLocal();
    const linkObjA = LinkConfigAll[locale] || LinkConfigAll['us'];
    const [isOpen, setIsOpen] = useState(false); //是否打开弹窗
    const [priceA, setPriceA] = useState(0);
    const [priceB, setPriceB] = useState(0);
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    const SITE_ID: any = {
        us: '4423',
        ca: '4424',
    };
    const fields_Arr: any = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // 日期字段
        {
            id: '11149',
            type: 'text',
            value: dateString,
            overwrite: true,
        },
    ];
    const BtnText1 = () => {
        return (
            <div className="OtherA-btn1">
                <div className="OtherA-btn1-text1">{t('btn1')}</div>
                <div className="OtherA-btn1-text2">
                    <BtnA />
                </div>
            </div>
        );
    };
    const listA = [
        {
            isAmazon: true,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348822/a1.png',
            label: t('item1_label'),
            title: t('item1_title'),
            h5Title: t('item1_title'),
            desc: t('item1_desc'),
            buyText: t('btn2'),
            buyLink: isStatusNext ? linkObjA.itemA1 : null,
            moreText: <BtnText1 />,
            moreLink: isStatusNext ? linkObjA.itemA2 : null,
            icons: [
                {
                    icon: <span className="comp-icon-c"></span>,
                    title: t('item1_text1'),
                },
                {
                    icon: <span className="comp-icon-b"></span>,
                    title: t('item1_text2'),
                },
                {
                    icon: <span className="comp-icon-d"></span>,
                    title: t('item1_text3'),
                },
                {
                    icon: <span className="comp-icon-a"></span>,
                    title: t('item1_text4'),
                },
            ],
            priceLabel: isStatusNext ? (
                <div className="OtherA-price-a">
                    <span className="OtherA-price1">{FormatMoneyLocal(priceA, locale)}</span>
                    <span className="OtherA-price2">{FormatMoneyLocal(priceB, locale)}</span>
                </div>
            ) : (
                <div className="OtherA-price-b">{isStatusNext ? t('price_label') : t('price_label_a')}</div>
            ),
        },
        {
            openNoticeWin: true,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348988/a2.png',
            label: t('item2_label'),
            title: t('item2_title'),
            h5Title: t('item2_title_h5'),
            desc: t('item2_desc'),
            moreText: t('btn3'),
            moreLink: null,
            showMoreLink: isStatusNext ? true : false,
            icons: [
                {
                    icon: <span className="comp-icon-b"></span>,
                    title: t('item2_text1'),
                },
                {
                    icon: <span className="comp-icon-e"></span>,
                    title: t('item2_text2'),
                },
                {
                    icon: <span className="comp-icon-d"></span>,
                    title: t('item2_text3'),
                },
                {
                    icon: <span className="comp-icon-a"></span>,
                    title: t('item2_text4'),
                },
            ],
            priceLabel: <div className="OtherA-price-b">{isStatusNext ? t('price_label2') : t('price_label2_a')}</div>,
        },
        {
            openNoticeWin: true,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1722949348633/a3.png',
            label: t('item3_label'),
            title: t('item3_title'),
            h5Title: t('item3_title'),
            desc: t('item3_desc'),
            moreText: t('btn3'),
            moreLink: null,
            showMoreLink: isStatusNext ? true : false,
            icons: [
                {
                    icon: <span className="comp-icon-b"></span>,
                    title: t('item3_text1'),
                },
                {
                    icon: <span className="comp-icon-e"></span>,
                    title: t('item3_text2'),
                },
                {
                    icon: <span className="comp-icon-d"></span>,
                    title: t('item3_text3'),
                },
                {
                    icon: <span className="comp-icon-a"></span>,
                    title: t('item3_text4'),
                },
            ],
            priceLabel: <div className="OtherA-price-b">{isStatusNext ? t('price_label3') : t('price_label3_a')}</div>,
        },
    ];

    // 手机端的切换
    const [activeIndex, setActiveIndex] = useState(0);
    // 点击切换
    const toggleHandle = (index: number) => {
        setActiveIndex(index);
    };

    // 点击 notice
    const noticeHandle = (item: any) => {
        if (item.openNoticeWin) {
            setIsOpen(true);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join',
                button_name: item.moreText,
            });
        } else if (item.isAmazon) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy_on_amazon',
                product_name: t('item1_title'),
                button_name: `${t('btn1')} amazon`,
                list_name: t('title'),
            });
        }
    };
    // 关闭弹窗
    const closeHandle = () => {
        setIsOpen(false);
    };

    // 产品列表
    const productList = [
        {
            value: 6,
            label: t('win_product1'),
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 6,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
        {
            value: 7,
            label: t('win_product2'),
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 7,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
    ];

    useEffect(() => {
        const initAll = async () => {
            const variantIdA = linkObjA.variantId;
            const res = await getSolarRecommand2({ variantIds: [variantIdA] }, locale);
            if (res.code === '0') {
                const data = res.data || [];
                //第1个产品
                const itemA2 = data.find((item: any) => {
                    return item.variantId === variantIdA;
                });
                if (itemA2) {
                    setPriceA(itemA2.price);
                    setPriceB(itemA2.compareAtPrice);
                }
            }
        };
        if (isStatusNext) {
            initAll();
        }
    }, []);

    return (
        <div className={`${styles.TheComp} ${styles.TheComp2} ${styles.CompIcon}`} id="id-OtherA">
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            {pageStatus === IPageStatus.statusA && <EmailBox contactListId={CONTACT_LIST_ID[locale]} fields={fields_Arr} />}
            <div className="ef-container">
                <div className="OtherA-cc">
                    <div className="OtherA-cc-a">{t('cc_1')}</div>
                    <div className="OtherA-cc-b">
                        <span className="OtherA-cc-b-l">{t('cc_2')}</span>
                        <span className="OtherA-cc-b-r">{t('cc_3')}</span>
                    </div>
                    <div className="OtherA-cc-c">
                        <IconAdd />
                    </div>
                    <div className="OtherA-cc-d">{t('cc_4')}</div>
                    <div className="OtherA-cc-e">
                        <div className="OtherA-cc-e-img1">
                            <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724149682378/aa1.png" />
                        </div>
                        <div className="OtherA-cc-e-img2">{t('cc_5')}</div>
                    </div>
                    <div className="OtherA-cc-f">{t('cc_6')}</div>
                </div>
            </div>

            <div className={`ef-container Other-in1 pageStatus-${pageStatus} pageStatus-${locale}`}>
                {listA.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfShopIconsA
                                {...item}
                                className={`Other-in-item Other-in-item-${index + 1}${activeIndex === index ? ' Other-active' : ''}`}
                                moreCallback={() => {
                                    noticeHandle(item);
                                }}
                            />
                        </Fragment>
                    );
                })}
            </div>

            <div className="ef-container Other-in2">
                {listA.map((item: any, index: number) => {
                    return (
                        <div
                            className={`Other-in2-item${activeIndex === index ? ' Other-active' : ''}`}
                            key={index}
                            onClick={() => {
                                toggleHandle(index);
                            }}
                        >
                            {item.h5Title || item.title}
                        </div>
                    );
                })}
            </div>
            <EfSpec />
            <EfEmarsysDialogB
                open={isOpen}
                contactListId={CONTACT_LIST_ID[locale]}
                productList={productList}
                isMulti={true}
                fields={fields_Arr}
                pc="https://websiteoss.ecoflow.com/upload/image/1724566389643/bb1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724566389552/bb2.jpg"
                callback={closeHandle}
                title={t('win_title1')}
                title2={t('win_title2')}
            />
        </div>
    );
}
